import { render, staticRenderFns } from "./EditOrderDetails.vue?vue&type=template&id=49db53d6&scoped=true"
import script from "./EditOrderDetails.vue?vue&type=script&lang=js"
export * from "./EditOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./EditOrderDetails.vue?vue&type=style&index=0&id=49db53d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49db53d6",
  null
  
)

export default component.exports